export const unitFaq = {
  head: {
    title: "Preguntas y respuestas de la unidad",
    chip: "IA",
    subPre: "Respuestas específicas de",
    subStrong: "esta unidad",
    subPost: ". El agente las usará con prioridad cuando atienda a un huésped alojado aquí (p. ej. el código de su puerta, peculiaridades de este piso…). Adjunta imágenes o vídeos y el agente los enviará cuando el huésped los necesite.",
  },
  clone: {
    titleNoun: "preguntas frecuentes",
    itemNoun: "las preguntas frecuentes",
    buttonLabel: "Clonar preguntas",
  },

  copyOne: {
    title: "Copiar esta pregunta",
    itemNoun: "pregunta",
  },
  loading: "Cargando…",
  emptyList: "Aún no hay preguntas. Añade la primera para que el agente sepa responderla.",
  list: {
    newQuestion: "Nueva pregunta",
    attachments: "{count} adjunto | {count} adjuntos",
    learnedTitle: "Incorporada por autoaprendizaje",
    deleteTitle: "Eliminar",
    copyTitle: "Copiar a otras unidades",
  },
  form: {
    questionLabel: "Pregunta",
    answerLabel: "Respuesta del agente",
    qPlaceholder: "Pregunta · Ej: ¿Cuál es el código de la puerta?",
    aPlaceholder: "Respuesta · Ej: El código del portal de tu piso es 4512.",
    removeAttachment: "Quitar adjunto",
    uploading: "Subiendo…",
    attach: "Adjuntar",
    addQuestion: "Añadir pregunta",
  },
  preview: {
    tag: "Vista previa · WhatsApp",
    online: "en línea",
    aiReception: "Recepción IA",
    questionPlaceholder: "Escribe la pregunta del huésped…",
    answerPlaceholder: "Escribe la respuesta que dará el agente…",
    videoFile: "Vídeo",
    genericFile: "Archivo",
    empty: "Selecciona o crea una pregunta para ver cómo responderá el agente.",
    hint: "Así lo verá el huésped en su chat",
  },
  footer: {
    saved: "Guardado",
    save: "Guardar cambios",
  },
  errors: {
    load: "No se pudieron cargar las preguntas.",
    attachNeedsQA: "Escribe la pregunta y la respuesta antes de adjuntar archivos.",
    attachNeedsSave: "Guarda primero para poder adjuntar archivos.",
    upload: "No se pudo subir el archivo.",
    deleteFile: "No se pudo eliminar el archivo.",
    save: "No se pudo guardar.",
  },
};
